import React, { useMemo } from "react";
import SaasFlyersOrder from "./SaasFlyersOrder";
import { useSelector } from "react-redux";
import { type RootStateI } from "../../redux";
import KC_Separator from "../../designsystem/KC_Separator/KC_Separator";
import { KC_Sizes } from "../../designsystem/ds_commons";
import SaasFlyersOrderQuantitySelection from "./components/SaasFlyersOrderQuantitySelection";
import SaasFlyersOrderDelivery from "./components/SaasFlyersOrderDelivery";
import SaasFlyersOrderPayment from "./components/SaasFlyersOrderPayment";
import { tt } from "../../utils/i18n/i18n";
import {
  FLYERS_ORDER_STEP_DELIVERY,
  FLYERS_ORDER_STEP_PAYMENT,
  FLYERS_ORDER_STEP_QUANTITY
} from "../../utils/constants";

const SaasFlyersOrderContainer = () => {
  const saasFlyersOrderSection = useSelector(
    (state: RootStateI) => state.saas.flyersOrderStep
  );

  const element = useMemo(() => {
    return flyersOrderComponentsMap.get(
      saasFlyersOrderSection || FLYERS_ORDER_STEP_PAYMENT
    );
  }, [saasFlyersOrderSection]);

  return (
    <div>
      <SaasFlyersOrder
        Component={element.Component}
        subheading={element.subheading}
        description={element.description}
      />
      <KC_Separator size={KC_Sizes.l} />
    </div>
  );
};

export default SaasFlyersOrderContainer;

const flyersOrderComponentsMap = new Map();
flyersOrderComponentsMap.set(FLYERS_ORDER_STEP_QUANTITY, {
  Component: SaasFlyersOrderQuantitySelection,
  subheading: "",
  description: tt("saas_flyers_order_quantity_description")
});
flyersOrderComponentsMap.set(FLYERS_ORDER_STEP_DELIVERY, {
  Component: SaasFlyersOrderDelivery,
  subheading: "",
  description: tt("saas_flyers_order_delivery_description")
});
flyersOrderComponentsMap.set(FLYERS_ORDER_STEP_PAYMENT, {
  Component: SaasFlyersOrderPayment,
  subheading: tt("saas_flyers_order_payment_subheading"),
  description: tt("saas_flyers_order_payment_description")
});
